import React, {useEffect, useState} from 'react';
import {withTranslation} from 'react-i18next';
import {compose} from 'redux';
import {Accordion, AccordionDetails, AccordionSummary, Box, Container, Grid, Typography,} from '@mui/material';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import OImg from "./../OImg";
import OpenCloseWysiwigContent from "./../OpenCloseWysiwigContent";

const PresentationComponent = ({presentation}) => {
    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
        window.location.hash = isExpanded ? panel : '';
    };

    useEffect(() => {
         const anchor = window.location.hash.split("#")[1];
         console.log(anchor);
         if (anchor) {
             const anchorEl = document.getElementById('accordion-' + anchor);
             if (anchorEl) {
                 setExpanded(anchor);
                 setTimeout(() => {
                     anchorEl.scrollIntoView({ block: "nearest", behavior: 'smooth' });
                 }, 500);

             }
         }
    }, []);

    return (
        <Container maxWidth="md" className="secteurListContent" disableGutters={true}>
            <Grid container className="h-100 mt-0">
                {presentation.media?.url && <Grid item xs={12} lg={4}>
                    <OImg src={presentation.media.url}
                          wrapperClassName={'text-center'}
                          className={'adjust-width'}
                          alt={presentation.label}
                          height={presentation.media.height + 'px'}/>
                </Grid>}
                <Grid item xs={12} lg={presentation.media?.url ? 8 : 12}>
                    <Box sx={{ p: 1, }}>
                        <h2 className="mt-2 mb-3 text-tertiary">
                            {presentation.label}
                        </h2>
                        <OpenCloseWysiwigContent description={presentation.description} descriptionShort={presentation.description_short} />
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    {/*<Box sx={{ p: 1, }}>*/}
                        {presentation.presentationTabsEnabled.map(accordion => {
                            return (<Accordion
                                id={`accordion-${accordion.slug}`}
                                className={"AccordionSummaryOddEven"}
                                expanded={expanded === accordion.slug}
                                onChange={handleChange(accordion.slug)}
                                key={accordion.slug}
                            >
                                <AccordionSummary
                                    className={"accordionSummarySticky"}
                                    expandIcon={<FontAwesomeIcon icon={["fas", "chevron-down"]} size="sm" className="primary" />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    expanded={false}
                                >
                                    <Typography variant={"h3"}>{accordion.label}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p className="wysiwyg" dangerouslySetInnerHTML={{__html: accordion.description}}/>
                                </AccordionDetails>
                            </Accordion>)
                        })}
                    {/*</Box>*/}
                </Grid>
            </Grid>
        </Container>
    );
};

export default compose(
    withTranslation()
)(PresentationComponent);
